module.exports = __webpack_public_path__ + "img/img-1.f43f8d38.png";